const PARTNER = 'partner';
const ADMIN = 'admin';
const CLINIC = 'clinic';

const BUILD_TYPE = PARTNER;

export const isBuildTypePartner = () => {
    return BUILD_TYPE === PARTNER;
};

export const isBuildTypeAdmin = () => {
    return BUILD_TYPE === ADMIN;
};

export const isBuildTypeClinic = () => {
    return BUILD_TYPE === CLINIC;
};
